import { IContext } from "@src/context";
import { isOfficeHours } from "./officeHours";
import { isMobile } from "./matchMedia";

export function replacePhoneLinkWithEnquiryFormOnMobile(context: IContext) {
  const links = document.querySelectorAll("[data-call-to-enquiry]");
  const isOfficeHoursNow = isOfficeHours(context.locale);

  if (isMobile() && !isOfficeHoursNow) {
    links.forEach((link) => {
      link.removeAttribute("href");
      link.setAttribute("data-popup-id", "enquiry-form");
      link.setAttribute("data-popup-event", "popup-open");
    });
  }
}
